import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mascot } from "../components/Mascot";
import { MediGenieLogo } from "../components/MediGenieLogo";
import { useAuth } from "../lib/auth";

export default function ClinicUnavailable() {
  const { user } = useAuth();
  const [reason, setReason] = useState("This clinic is currently unavailable. Please contact MediGenie support.");
  useEffect(() => {
    if (user?.clinic_access?.reason) setReason(user.clinic_access.reason);
  }, [user]);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-gradient-to-b from-slate-50 to-blue-50/30">
      <MediGenieLogo />
      <div className="mt-10 mg-card max-w-lg">
        <Mascot size={120} variant="main" className="mx-auto mg-float" />
        <h1 className="text-2xl font-extrabold text-mg-navy mt-4">Clinic currently unavailable</h1>
        <p className="text-sm text-mg-secondary mt-3 leading-relaxed" data-testid="clinic-unavailable-reason">{reason}</p>
        <div className="mt-5 flex flex-col gap-2">
          <Link to="/" className="mg-btn-secondary justify-center">Back to homepage</Link>
          <a href="mailto:support@medigenie.in" className="text-xs text-mg-medical font-semibold">support@medigenie.in</a>
        </div>
      </div>
    </div>
  );
}
